import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './store/alert.module';
import { users } from './store/users.module';
import { routes } from './store/routes.module';
import { reservations } from './store/reservations.module';
import { products } from './store/products.module';
import { pois } from './store/pois.module';
import { pages } from './store/pages.module';
import { orders } from './store/orders.module';
import { news } from './store/news.module';
import { newsletter } from './store/newsletter.module';
import { hero } from './store/hero.module';
import { gallery } from './store/gallery.module';
import { favorites } from './store/favorites.module';
import { faqs } from './store/faqs.module';
import { events } from './store/events.module';
import { categories } from './store/categories.module';
import { cart } from './store/cart.module';

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  namespaced: true,
  state,
  mutations,
  modules: {alert,users,routes,reservations,products,pois,pages,orders,news,newsletter,hero,gallery,favorites,faqs,events,categories,cart}
});